import React, { useState } from "react";
import { sendMail } from "../../utils/sendMail";
import ReCAPTCHA from "react-google-recaptcha";

const ContactForm = () => {

  const [formData, setFormData] = useState({
    enquiry: "",
    name: "",
    email: "",
    mobile: ""
  });

  const [captcha, setCaptcha] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const SITE_KEY = "6LfwpoIsAAAAAKbfErRtUze2pr2wTzHa22cEoucS";

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validate = () => {

    let newErrors = {};

    if (!formData.enquiry.trim())
      newErrors.enquiry = "Enquiry is required";

    if (!formData.name.trim())
      newErrors.name = "Name is required";

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Valid email required";

    if (!/^[0-9]{10}$/.test(formData.mobile))
      newErrors.mobile = "Enter valid 10 digit mobile number";

    if (!captcha)
      newErrors.captcha = "Please verify captcha";

    return newErrors;
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    try {

      const response = await sendMail({
        ...formData,
        captcha
      });

      if (response.status === "success") {

        alert("Message sent successfully");

        setFormData({
          enquiry: "",
          name: "",
          email: "",
          mobile: ""
        });

        setCaptcha(null);
        setErrors({});

      } else {
        alert("Failed to send message");
      }

    } catch (error) {
      console.error(error);
      alert("Server error");
    }

    setLoading(false);
  };

  return (
    <section className="section-form-wrapper section-padding">
      <div className="container">
        <form className="contact-page-form" onSubmit={handleSubmit}>

          <input
            type="text"
            name="enquiry"
            placeholder="Enquiry"
            value={formData.enquiry}
            onChange={handleChange}
          />
          {errors.enquiry && <p>{errors.enquiry}</p>}

          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <p>{errors.name}</p>}

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p>{errors.email}</p>}

          <input
            type="tel"
            name="mobile"
            placeholder="Mobile Number"
            value={formData.mobile}
            onChange={handleChange}
          />
          {errors.mobile && <p>{errors.mobile}</p>}

          <div style={{marginTop:"15px"}}>
            <ReCAPTCHA
              sitekey={SITE_KEY}
              onChange={(value)=>setCaptcha(value)}
            />
          </div>

          {errors.captcha && <p>{errors.captcha}</p>}

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Submit"}
          </button>

        </form>
      </div>
    </section>
  );
};

export default ContactForm;